import { ArrowBack as ArrowBackIcon, } from "@mui/icons-material";

import { Box, Chip, IconButton, Typography } from "@mui/material";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { useNavigate } from "react-router-dom";
import { objColorsChipsFunctionProducer } from "src/shared/ColorObj/ColorsChipsFunctionProducer";
import { ChipCore } from "src/Pages/components/ChipCore/ChipCore";
import { useProducerInternalData } from "../hooks/useProducerInternalData";

export const HeaderInternalProducer = () => {
  const navigate = useNavigate();
  const { producerForm, producerListItem } = useProducerInternalData();

  return (
    <CardCore sxStyle={{ margin: 0 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          gap: 2,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
              {producerListItem?.id} - {producerForm.nome || "Produtor"}
            </Typography>

            <Box sx={{ display: "flex", gap: 0.8, mt: 0.5, flexWrap: "wrap" }}>
              <ChipCore
                size="small"
                colorCore={objColorsChipsFunctionProducer[producerForm.funcao_produtor].color}
                label={objColorsChipsFunctionProducer[producerForm.funcao_produtor].label}
                icon={objColorsChipsFunctionProducer[producerForm.funcao_produtor].icon}
                sxStyle={{ width: "110px" }}
              />

              <Chip size="small" label={producerForm.fisico_juridico === "fisica" ? "PF" : "PJ"} />

              {producerListItem && (
                <Chip
                  size="small"
                  color={producerListItem.is_active_producer ? "success" : "error"}
                  label={producerListItem.is_active_producer ? "Ativo" : "Inativo"}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </CardCore>
  );
};
